const asEmbed = (src) => ({ type: 'embed', src });

export const resolveVideoSource = (value) => {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw) return { type: 'video', src: '' };

  let url;
  try {
    url = new URL(raw);
  } catch {
    return { type: 'video', src: raw };
  }

  const host = url.hostname.toLowerCase().replace(/^www\./, '');
  const pathParts = url.pathname.split('/').filter(Boolean);

  if (host === 'player.mediadelivery.net' || host === 'iframe.mediadelivery.net') {
    const bunnyPath = url.pathname.match(/^\/(?:play|embed)\/([^/]+)\/([^/]+)\/?$/i);
    if (bunnyPath) {
      url.protocol = 'https:';
      url.hostname = 'player.mediadelivery.net';
      url.pathname = `/embed/${bunnyPath[1]}/${bunnyPath[2]}`;
      return asEmbed(url.toString());
    }
  }

  if (host === 'youtu.be' || host === 'youtube.com' || host.endsWith('.youtube.com') ||
      host === 'youtube-nocookie.com' || host.endsWith('.youtube-nocookie.com')) {
    const pathId = url.pathname.match(/\/(?:embed|shorts|live)\/([^/?]+)/i)?.[1];
    const videoId = host === 'youtu.be'
      ? pathParts[0]
      : url.searchParams.get('v') || pathId;
    if (videoId) {
      return asEmbed(`https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?rel=0`);
    }
  }

  if (host === 'vimeo.com' || host.endsWith('.vimeo.com')) {
    const videoId = [...pathParts].reverse().find((part) => /^\d+$/.test(part));
    if (videoId) return asEmbed(`https://player.vimeo.com/video/${videoId}`);
  }

  if (host === 'drive.google.com' || host === 'docs.google.com') {
    const pathId = url.pathname.match(/\/file\/d\/([^/]+)/)?.[1];
    const fileId = pathId || url.searchParams.get('id');
    if (fileId) {
      return asEmbed(`https://drive.google.com/file/d/${encodeURIComponent(fileId)}/preview`);
    }
  }

  if (host === 'loom.com' || host.endsWith('.loom.com')) {
    const videoId = url.pathname.match(/\/(?:share|embed)\/([^/]+)/)?.[1];
    if (videoId) return asEmbed(`https://www.loom.com/embed/${encodeURIComponent(videoId)}`);
  }

  if (host === 'wistia.com' || host.endsWith('.wistia.com') || host === 'wi.st') {
    const videoId = url.pathname.match(/\/(?:medias|embed\/iframe)\/([a-z0-9]+)/i)?.[1];
    if (videoId) return asEmbed(`https://fast.wistia.net/embed/iframe/${encodeURIComponent(videoId)}`);
  }

  if (host === 'dropbox.com' || host.endsWith('.dropbox.com')) {
    url.searchParams.set('raw', '1');
  }

  return { type: 'video', src: url.toString() };
};
